
import { NecessaryTime, NecessaryTimeMap, stationId } from "@/types";
import { computed, defineComponent, PropType } from "vue";
import rfdc from "rfdc";
import { useStore } from "@/store";

const clonedeep = rfdc();

export default defineComponent({
  props: {
    modelValue: Object as PropType<NecessaryTimeMap>,
    boundFor: String as PropType<"A" | "B">,
    editable: { type: Boolean, default: true },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const necessaryTimeArray = computed(() => {
      if (!props.modelValue) return [];
      return [...props.modelValue.values()];
    });
    const store = useStore();

    const getStationName = computed(
      () => (id: stationId) => store.getters.getStation(id)?.name
    );
    const onCellEditComplete = (
      e: Event & { data: NecessaryTime; field: string }
    ) => {
      if (!props.modelValue) return;
      const newNecessaryTimeMap = clonedeep(props.modelValue);
      newNecessaryTimeMap.set(e.data.id, e.data);
      context.emit("update:modelValue", newNecessaryTimeMap);
    };

    return {
      necessaryTimeArray,
      onCellEditComplete,
      getStationName,
    };
  },
});
